/** Checks that a value that might be undefined/null actually exists */
export function isExistent<T>(arg: T | null | undefined): arg is T {
  return typeof arg !== 'undefined' && arg !== null
}
